import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Component6cards from '../components/component6cards'
import FooterMain from '../components/footer-main'
import './custom-robotic.css'

const CustomRobotic = (props) => {
  return (
    <div className="custom-robotic-container">
      <Helmet>
        <title>Специальные робототехнические комплексы под ключ | Arcobo</title>
        <meta
          name="description"
          content="Инжиниринг и внедрение роботизированных систем для маркировки, контроля качества, сборки, нанесения клея и машинного зрения под ключ."
        />
        <meta
          property="og:title"
          content="Специальные робототехнические комплексы под ключ | Arcobo"
        />
        <meta
          property="og:description"
          content="Инжиниринг и внедрение роботизированных систем для маркировки, контроля качества, сборки, нанесения клея и машинного зрения под ключ."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Специальные робототехнические комплексы под ключ | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Инжиниринг и внедрение роботизированных систем для маркировки, контроля качества, сборки, нанесения клея и машинного зрения под ключ."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/custom-robotic"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/custom-robotic"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"CustomRobotic","item":"https://arcobo.tech/custom-robotic"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name12"></HeaderMain>
      <hr className="custom-robotic-separator1"></hr>
      <Component6cards
        titleAs="h1"
        componentText="Проектируем и создаем роботизированные системы под задачи конкретного предприятия - от единичных установок до комплексных производственных линий"
        feature1Title="Лазерная маркировка рам"
        feature2Title="TIG-наплавка запорной арматуры"
        feature3Title="Контроль качества драгоценных металлов"
        feature4Title="Система нанесения герметика"
        feature5Title="Комплекс для пайки печатных плат"
        feature6Title="Не нашли подходящее решение?"
        rootClassName="component6cardsroot-class-name3"
        componentTitle="Специальные робототехнические комплексы"
        feature1ImageSrc="/1_Solution/1_1_4 Special/11%20%C3%B0%C2%9B%C3%B0%C2%B0%C3%B0%C2%B7%C3%B0%C2%B5%C3%B1%C2%80-1500w.webp"
        feature1ImageAlt="Лазерная маркировка рам"
        feature2ImageSrc="/1_Solution/1_1_4 Special/12%20%C3%B0%C2%9D%C3%B0%C2%B0%C3%B0%C2%BF%C3%B0%C2%BB%C3%B0%C2%B0%C3%B0%C2%B2%C3%B0%C2%BA%C3%B0%C2%B0-300h.webp"
        feature2ImageAlt="TIG-наплавка запорной арматуры"
        feature3ImageSrc="/1_Solution/1_1_4 Special/13%20%C3%B0%C2%9A%C3%B0%C2%BE%C3%B0%C2%BD%C3%B1%C2%80%C3%B0%C2%BE%C3%B0%C2%BB%C3%B1%C2%8C%20%C3%B0%C2%B4%C3%B1%C2%80%C3%B0%C2%B0%C3%B0%C2%B3%C3%B0%C2%BE%C3%B1%C2%86%C3%B0%C2%B5%C3%B0%C2%BD%C3%B0%C2%BD%C3%B1%C2%8B%C3%B1%C2%85-300h.webp"
        feature3ImageAlt="Контроль качества драгоценных металлов"
        feature4ImageSrc="/1_Solution/1_1_4 Special/14%20%C3%B0%C2%93%C3%B0%C2%B5%C3%B1%C2%80%C3%B0%C2%BC%C3%B0%C2%B5%C3%B1%C2%82%C3%B0%C2%B8%C3%B0%C2%BA-1500w.webp"
        feature4ImageAlt="Система нанесения герметика"
        feature5ImageSrc="/1_Solution/1_1_4 Special/15%20%C3%B0%C2%9F%C3%B0%C2%B0%C3%B0%C2%B9%C3%B0%C2%BA%C3%B0%C2%B0-300h.webp"
        feature5ImageAlt="Комплекс для пайки печатных плат"
        feature6ImageSrc="/1_Solution/1_1_4 Special/16%20%C3%B0%C2%AF%C3%B1%C2%87%C3%B0%C2%B5%C3%B0%C2%B9%C3%B0%C2%BA%C3%B0%C2%B0-300h.webp"
        feature6ImageAlt="Специальные робототехнические комплексы"
        showComponentText
        showComponentTitle
        feature1Description={
          <Fragment>
            <span className="custom-robotic-thq-feature1-description-elm1 thq-body-small">
              <span>
                Роботизированная система для автоматического нанесения
                идентификаторов и маркировки на металлические рамы
              </span>
              <br className="custom-robotic-text11"></br>
              <br></br>
              <span className="custom-robotic-text13">
                ✓
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Точность позиционирования до ±0,07 мм</span>
              <br className="custom-robotic-text15"></br>
              <span className="custom-robotic-text16">✓</span>
              <span>
                {' '}
                Автоматическое формирование маркировки по 3D-модели изделия
              </span>
              <br className="custom-robotic-text18"></br>
              <span className="custom-robotic-text19">✓</span>
              <span>
                {' '}
                100% контроль качества нанесения перед передачей изделия
              </span>
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="custom-robotic-thq-feature1-description-elm2 thq-body-small">
              <span>
                Роботизированный комплекс для восстановления запорной арматуры
                предприятий энергетики, нефтегазовой и химической промышленности
              </span>
              <br className="custom-robotic-text22"></br>
              <br></br>
              <span className="custom-robotic-text24">✓</span>
              <span>
                {' '}
                Рост производительности до 25 раз за счет стабильного качества
                без пор и человеческого фактора
              </span>
              <br className="custom-robotic-text26"></br>
              <span className="custom-robotic-text27">
                ✓
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Наплавка внутренних поверхностей от Ø76 мм</span>
              <br className="custom-robotic-text29"></br>
              <span className="custom-robotic-text30">
                ✓
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Автоматическое определение профиля детали и траектории наплавки
              </span>
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="custom-robotic-text32">
              <span>
                Роботизированная система контроля качества изделий из
                драгоценных металлов
              </span>
              <br></br>
              <br></br>
              <span className="custom-robotic-text36">✓</span>
              <span> 100% автоматический контроль каждого изделия</span>
              <br></br>
              <span className="custom-robotic-text39">✓</span>
              <span>
                {' '}
                Машинное зрение для обнаружения дефектов поверхности и геометрии
              </span>
              <br></br>
              <span className="custom-robotic-text42">✓</span>
              <span>
                {' '}
                Автоматическая идентификация изделий и сортировка по заданным
                критериям
              </span>
            </span>
          </Fragment>
        }
        feature4Description={
          <Fragment>
            <span className="custom-robotic-text44">
              <span>
                Роботизированный комплекс для высокоточного нанесения герметика
                на изделия любой сложности.
              </span>
              <br></br>
              <br></br>
              <span className="custom-robotic-text48">
                ✓
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Стабильная дозировка на всей длине шва</span>
              <br></br>
              <span className="custom-robotic-text51">✓</span>
              <span>
                {' '}
                Автоматическое нанесение по сложным пространственным контурам
              </span>
              <br></br>
              <span className="custom-robotic-text54">✓</span>
              <span>
                {' '}
                Минимальный расход материала и отсутствие человеческого фактора
              </span>
            </span>
          </Fragment>
        }
        feature5Description={
          <Fragment>
            <span className="custom-robotic-text56">
              <span>
                Автоматизированная система прецизионной пайки электронных
                компонентов и печатных плат.
              </span>
              <br></br>
              <br></br>
              <span className="custom-robotic-text60">✓</span>
              <span> Высокая повторяемость каждой операции пайки</span>
              <br></br>
              <span className="custom-robotic-text63">✓</span>
              <span>
                {' '}
                Работа с миниатюрными и чувствительными электронными
                компонентами
              </span>
              <br></br>
              <span className="custom-robotic-text66">✓</span>
              <span>
                {' '}
                Автоматический контроль качества и стабильности процесса
              </span>
            </span>
          </Fragment>
        }
        feature6Description={
          <Fragment>
            <span className="custom-robotic-text68">
              <span>
                Разрабатываем специализированные системы под задачи вашего
                производства.
              </span>
              <br></br>
              <br></br>
              <span className="custom-robotic-text72">✓</span>
              <span> Анализ технологии и подбор оптимальной концепции</span>
              <br></br>
              <span className="custom-robotic-text75">✓</span>
              <span>
                {' '}
                Проектирование, изготовление и программирование комплекса
              </span>
              <br></br>
              <span className="custom-robotic-text78">✓</span>
              <span>
                {' '}
                Полный цикл реализации – от идеи до ввода в эксплуатацию
              </span>
            </span>
          </Fragment>
        }
      ></Component6cards>
      <hr className="custom-robotic-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name12"></FooterMain>
    </div>
  )
}

export default CustomRobotic
